import React, { useEffect, useMemo, useRef, useState } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import { useLocation, useNavigate } from "react-router-dom";
import { URLS } from "../../Services/Constant";
import { get, post } from "../../Services/ApiHandler";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { approve, reject } from "../../assets/img/imgIndex";
import ReasonModal from "../../components/ReasonModal/ReasonModal";
import { toast } from "react-toastify";

const DriverVerification = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [documents, setDocuments] = useState({
    aadhaarFront: null,
    aadhaarBack: null,
    panFront: null,
    panBack: null,
    licenseFront: null,
    licenseBack: null,
    rcFront: null,
    rcBack: null,
    vehicleImages: [],
  });

  const [vehicleDetails, setVehicleDetails] = useState({
    vehicleName: "",
    vehicleModel: "",
    vehicleNumber: "",
  });

  const tabRef = useRef(2);
  const statePage = location?.state?.page;
  const page = statePage || 1;

  const [preview, setPreview] = useState(null);

  const [message, setMessage] = useState("");

  const aadhaarFrontRef = useRef(null);
  const aadhaarBackRef = useRef(null);

  const panFrontRef = useRef(null);
  const panBackRef = useRef(null);

  const licenseFrontRef = useRef(null);
  const licenseBackRef = useRef(null);

  const rcFrontRef = useRef(null);
  const rcBackRef = useRef(null);

  const vehicleImagesRef = useRef(null);

  const dispatch = useDispatch();
  const storedPartnerData = useSelector((state) => state?.deliveryPartnerView);

  const routePartnerId =
    location?.state?.id || location?.state?.data?.id || null;
  const id = routePartnerId || storedPartnerData?.deliveryPartnerId || null;
  const routeViewData = location?.state?.viewData;
  const viewData = routeViewData || storedPartnerData?.viewData || null;

  const isViewOnly = true;

  const [data, setData] = useState(null);

  const userData = useMemo(
    () => ({
      name: data?.name || "",
      created_at: data?.register_date || "",
      mob_no: data?.mobile_no || "",
      avg_rating: data?.ratings || 0,
      email: data?.email || "",
      profile_img_url: data?.profile_image || "",
      fssai_certificate_url: data?.fssai_certificate_url || "",
      overall_earnings: data?.overall_earnings || 0,
      user_type: data?.user_type || "-",
      reject_date: data?.reject_date || 0,
      rejection_reason: data?.rejection_reason || 0,
      vehicle_type: data?.vehicle_type,
      vehicle_type_name: data?.vehicle_type_name || "",
    }),
    [data],
  );

  const isCycle =
    userData?.vehicle_type === 2 || userData?.vehicle_type_name === "Cycle";
  const vehicleTypeLabel = isCycle ? "Bicycle" : "Motor bike";

  useEffect(() => {
    const fetchUserDetails = async () => {
      if (!id) return;
      try {
        const res = await get(
          `${URLS.DELIVERYPARTNER}${id}/?context=${viewData}`,
        );
        console.log("User BYID res:", res);
        const kycDetails = res?.data || {};
        if (res?.status === "success") {
          setData(kycDetails);

          setDocuments({
            aadhaarFront: buildDocumentFile(
              kycDetails?.aadhar_front,
              "Aadhaar Front",
            ),
            aadhaarBack: buildDocumentFile(
              kycDetails?.aadhar_back,
              "Aadhaar Back",
            ),
            panFront: buildDocumentFile(kycDetails?.pan_front, "PAN Front"),
            panBack: buildDocumentFile(kycDetails?.pan_back, "PAN Back"),
            licenseFront: buildDocumentFile(kycDetails?.dl_front, "DL Front"),
            licenseBack: buildDocumentFile(kycDetails?.dl_back, "DL Back"),
            rcFront: buildDocumentFile(kycDetails?.rc_front, "RC Front"),
            rcBack: buildDocumentFile(kycDetails?.rc_back, "RC Back"),
            vehicleImages: [
              buildDocumentFile(kycDetails?.vehicle_front, "Vehicle Front"),
              buildDocumentFile(kycDetails?.vehicle_back, "Vehicle Back"),
            ].filter(Boolean),
          });

          setVehicleDetails({
            vehicleModel: kycDetails?.vehicle_model,
            vehicleName: kycDetails?.vehicle_name,
            vehicleNumber: kycDetails?.vehicle_number,
          });
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    };

    fetchUserDetails();
  }, [id, viewData]);

  const buildDocumentFile = (url, fallbackName = "Document") => {
    if (!url) return null;
    const fileName = decodeURIComponent(
      (url.split("/").pop() || fallbackName).split("?")[0],
    );
    return {
      name: fileName || fallbackName,
      size: "Uploaded file",
      type: /\.pdf$/i.test(url) ? "application/pdf" : "image/jpeg",
      url,
    };
  };

  // --------------------------------------------------
  // Vehicle Images Upload
  // --------------------------------------------------

  const handleVehicleImages = (event) => {
    const files = Array.from(event.target.files || []);

    if (!files.length) return;

    const newImages = files.map((file) => ({
      file,
      name: file.name,
      size: formatFileSize(file.size),
      type: file.type,
      url: URL.createObjectURL(file),
    }));

    setDocuments((prev) => ({
      ...prev,
      vehicleImages: [...prev.vehicleImages, ...newImages],
    }));

    event.target.value = "";
  };

  // --------------------------------------------------
  // Remove Vehicle Image
  // --------------------------------------------------

  const removeVehicleImage = (index) => {
    setDocuments((prev) => ({
      ...prev,
      vehicleImages: prev.vehicleImages.filter(
        (_, imageIndex) => imageIndex !== index,
      ),
    }));
  };

  // --------------------------------------------------
  // Vehicle Input
  // --------------------------------------------------

  const handleVehicleChange = (event) => {
    const { name, value } = event.target;

    setVehicleDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // --------------------------------------------------
  // Preview
  // --------------------------------------------------

  const openPreview = (file) => {
    if (!file) return;

    setPreview(file);
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return "0 KB";

    const kb = bytes / 1024;

    if (kb < 1024) {
      return `${Math.round(kb)} KB`;
    }

    return `${(kb / 1024).toFixed(1)} MB`;
  };

  const [showReasonModal, setShowReasonModal] = useState(false);

  const handleReasonSubmit = async (reason) => {
    console.log("Submitted Reason:", reason);

    const res = await post(`${URLS.DRIVERVERIFICATION}${id}/`, {
      action: "reject",
      rejected_reason: reason,
    });
    if (res?.status === "success") {
      toast.success(res?.message || "Rejected Successfully");
      navigate("/delivery-partner", {
        state: {
          id: id,
          tab: tabRef.current,
          page: page,
        },
      });
    }
  };

  const handleApprove = async () => {
    const res = await post(`${URLS.DRIVERVERIFICATION}${id}/`, {
      action: "approve",
    });
    if (res?.status === "success") {
      toast.success(res?.message || "Approve Successfully");
      navigate("/delivery-partner", {
        state: {
          id: id,
          tab: tabRef.current,
          page: page,
        },
      });
    }
  };

  return (
    <div className="user-details-container">
      <PageHeader
        title="Verification"
        showBackButton={true}
        onBackClick={() => navigate("/delivery-partner")}
      />

      <div className="profile-header-card">
        <div className="profile-image-wrapper">
          <img
            src={
              userData?.profile_img_url ||
              "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?q=80&w=1887&auto=format&fit=crop"
            }
            alt="Profile"
          />
        </div>
        <div className="profile-info-main">
          <h2>{userData?.name || "N/A"}</h2>
        </div>
        <div className="profile-divider"></div>
        <div className="profile-details-grid">
          <div className="detail-item">
            <span className="detail-label">Register Date :</span>
            <span className="detail-value">
              {userData?.created_at ? userData?.created_at : "N/A"}
            </span>
          </div>
          {/* <div className="detail-item">
            <span className="detail-label">Email ID :</span>
            <span className="detail-value email">
              {userData?.email || "N/A"}
            </span>
          </div> */}
          <div className="detail-item">
            <span className="detail-label">Ratings :</span>
            <span className="detail-value">{userData?.avg_rating || 0}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Mobile No :</span>
            <span className="detail-value">
              {userData?.mob_no ? `+91-${userData?.mob_no}` : "N/A"}
            </span>
          </div>
          {data && (
            <div className="detail-item">
              <span className="detail-label">Vehicle Type :</span>
              <span className="detail-value">{vehicleTypeLabel}</span>
            </div>
          )}
        </div>
      </div>
      <div className="document-grid">
        {/* Aadhaar */}
        <DocumentCard
          title="Aadhaar Card"
          frontTitle="Front Side"
          backTitle="Back Side"
          frontFile={documents.aadhaarFront}
          backFile={documents.aadhaarBack}
          frontRef={aadhaarFrontRef}
          backRef={aadhaarBackRef}
          onFrontPreview={() => openPreview(documents.aadhaarFront)}
          onBackPreview={() => openPreview(documents.aadhaarBack)}
          isViewOnly={isViewOnly}
        />

        {/* PAN */}
        <DocumentCard
          title="PAN Card"
          frontTitle="Front View"
          backTitle="Back View"
          frontFile={documents.panFront}
          backFile={documents.panBack}
          frontRef={panFrontRef}
          backRef={panBackRef}
          onFrontPreview={() => openPreview(documents.panFront)}
          onBackPreview={() => openPreview(documents.panBack)}
          isViewOnly={isViewOnly}
        />

        {!isCycle && (
          <>
            <DocumentCard
              title="Driving License"
              frontTitle="Front Side"
              backTitle="Back Side"
              frontFile={documents.licenseFront}
              backFile={documents.licenseBack}
              frontRef={licenseFrontRef}
              backRef={licenseBackRef}
              onFrontPreview={() => openPreview(documents.licenseFront)}
              onBackPreview={() => openPreview(documents.licenseBack)}
              isViewOnly={isViewOnly}
            />
            <DocumentCard
              title="RC Book"
              frontTitle="Front Side"
              backTitle="Back Side"
              frontFile={documents.rcFront}
              backFile={documents.rcBack}
              frontRef={rcFrontRef}
              backRef={rcBackRef}
              onFrontPreview={() => openPreview(documents.rcFront)}
              onBackPreview={() => openPreview(documents.rcBack)}
              isViewOnly={isViewOnly}
            />
          </>
        )}
      </div>

      {/* --------------------------------------------- */}
      {/* Vehicle Details */}
      {/* --------------------------------------------- */}

      <h2 className="section-title">Vehicle Details</h2>

      <div className="vehicle-section">
        {/* Vehicle Images */}
        <div className="vehicle-image-card">
          <h4 style={{ fontSize: 16, marginBottom: 10 }}>Vehicle Images</h4>

          {!isViewOnly && (
            <>
              <input
                ref={vehicleImagesRef}
                type="file"
                accept="image/*"
                multiple
                hidden
                onChange={handleVehicleImages}
              />

              <div
                className="vehicle-upload"
                onClick={() => vehicleImagesRef.current?.click()}
              >
                {/* <Camera size={18} /> */}

                <span style={{ fontSize: 12 }}>
                  {documents.vehicleImages.length > 0
                    ? `${documents.vehicleImages.length} Image${
                        documents.vehicleImages.length > 1 ? "s" : ""
                      }`
                    : "Vehicle Images"}
                </span>

                <small style={{ fontSize: 11 }}>JPG / PNG</small>
              </div>
            </>
          )}

          {isViewOnly && (
            <div style={{ marginBottom: 8 }}>
              <span style={{ fontSize: 12 }}>
                {documents.vehicleImages.length > 0
                  ? `${documents.vehicleImages.length} Image${
                      documents.vehicleImages.length > 1 ? "s" : ""
                    }`
                  : "No Vehicle Images"}
              </span>
            </div>
          )}

          {/* Uploaded vehicle images */}
          {documents.vehicleImages.length > 0 && (
            <div className="vehicle-preview-list">
              {isViewOnly ? (
                <div className="vehicle-preview-single">
                  <img
                    src={documents.vehicleImages[0].url}
                    alt={`Vehicle`}
                    style={{
                      width: "100%",
                      height: "auto",
                      maxHeight: "60vh",
                      objectFit: "contain",
                      borderRadius: 8,
                      cursor: "pointer",
                    }}
                    onClick={() => openPreview(documents.vehicleImages[0])}
                  />
                </div>
              ) : (
                documents.vehicleImages.map((image, index) => (
                  <div className="vehicle-preview" key={index}>
                    <img
                      src={image.url}
                      alt={`Vehicle ${index + 1}`}
                      onClick={() => openPreview(image)}
                    />

                    {!isViewOnly && (
                      <button onClick={() => removeVehicleImage(index)}>
                        {/* <X size={12} /> */}
                      </button>
                    )}
                  </div>
                ))
              )}
            </div>
          )}
        </div>

        {!isCycle && (
        <div className="vehicle-form-card">
          <div className="input-group">
            <label style={{ fontSize: 12 }}>Vehicle Name</label>

            <input
              type="text"
              name="vehicleName"
              value={vehicleDetails.vehicleName}
              onChange={handleVehicleChange}
              placeholder="Enter vehicle name"
              readOnly
            />
          </div>

          <div className="input-group">
            <label style={{ fontSize: 12 }}>Vehicle Model</label>

            <input
              type="text"
              name="vehicleModel"
              value={vehicleDetails.vehicleModel}
              onChange={handleVehicleChange}
              placeholder="Enter vehicle model"
              readOnly
            />
          </div>

          <div className="input-group">
            <label style={{ fontSize: 12 }}>Vehicle Number</label>

            <input
              type="text"
              name="vehicleNumber"
              value={vehicleDetails.vehicleNumber}
              onChange={handleVehicleChange}
              placeholder="Enter vehicle number"
              onChangeCapture={(e) => {
                e.target.value = e.target.value.toUpperCase();
              }}
              readOnly
            />
          </div>
        </div>
        )}
      </div>

      {userData.rejection_reason ? (
        <div className="form-row mt-3">
          <div className="form-group">
            <label>Reject Date</label>
            <input
              type="text"
              value={userData.reject_date.split("T")[0] || ""}
              placeholder="Enter Reject Date"
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Rejection Reason</label>
            <textarea
              type="text"
              value={userData.rejection_reason || ""}
              placeholder="Enter Rejection Reason"
              readOnly
            />
          </div>
        </div>
      ) : (
        <div className="form-actions">
          <button
            type="button"
            className="btn-edit"
            onClick={() => setShowReasonModal(true)}
          >
            <img
              src={reject}
              width={12}
              height={12}
              style={{ marginRight: 4 }}
            />
            Reject
          </button>
          <button type="button" className="btn-save" onClick={handleApprove}>
            <img
              src={approve}
              width={18}
              height={18}
              style={{ marginRight: 4 }}
            />
            Approve
          </button>
        </div>
      )}

      {/* Save */}
      <div className="bottom-action">
        {message && (
          <div className="success-message">
            {/* <CheckCircle2 size={16} /> */}
            {message}
          </div>
        )}
      </div>

      {preview && (
        <div className="preview-overlay" onClick={() => setPreview(null)}>
          <div className="preview-modal" onClick={(e) => e.stopPropagation()}>
            <button className="preview-close" onClick={() => setPreview(null)}>
              {/* <X size={20} /> */}
            </button>

            {preview.type?.startsWith("image/") ? (
              <img src={preview.url} alt="Preview" className="preview-image" />
            ) : preview.type === "application/pdf" ||
              preview?.url?.toLowerCase?.().endsWith(".pdf") ? (
              <iframe
                src={`${preview.url}#toolbar=0`}
                title={preview.name}
                width="100%"
                height="100%"
                style={{ border: "none", borderRadius: 8 }}
              />
            ) : (
              <div className="file-preview">
                <h4 style={{ fontSize: 16, marginBottom: 10 }}>
                  {preview.name}
                </h4>

                <p>{preview.size}</p>
              </div>
            )}
          </div>
        </div>
      )}

      <ReasonModal
        isOpen={showReasonModal}
        onClose={() => setShowReasonModal(false)}
        onSubmit={handleReasonSubmit}
      />
    </div>
  );
};

// ==================================================
// Document Card Component
// ==================================================

const DocumentCard = ({
  title,
  frontTitle,
  backTitle,

  frontFile,
  backFile,

  frontRef,
  backRef,

  onFrontUpload,
  onBackUpload,

  onFrontPreview,
  onBackPreview,

  onFrontRemove,
  onBackRemove,
  isViewOnly,
}) => {
  return (
    <div className="document-card">
      <h4 style={{ fontSize: 16, marginBottom: 10 }}>{title}</h4>

      <div className="document-upload-row">
        {/* Front */}
        <DocumentUploadBox
          title={frontTitle}
          file={frontFile}
          inputRef={frontRef}
          onUpload={onFrontUpload}
          onPreview={onFrontPreview}
          onRemove={onFrontRemove}
          isViewOnly={isViewOnly}
        />

        {/* Back */}
        <DocumentUploadBox
          title={backTitle}
          file={backFile}
          inputRef={backRef}
          onUpload={onBackUpload}
          onPreview={onBackPreview}
          onRemove={onBackRemove}
          isViewOnly={isViewOnly}
        />
      </div>
    </div>
  );
};

// ==================================================
// Document Upload Box
// ==================================================

const DocumentUploadBox = ({
  title,
  file,
  inputRef,
  onUpload,
  onPreview,
  onRemove,
  isViewOnly,
}) => {
  return (
    <>
      {!isViewOnly && (
        <input
          ref={inputRef}
          type="file"
          accept="image/*,.pdf"
          hidden
          onChange={onUpload}
        />
      )}

      <div
        className={`document-box ${file ? "has-file" : ""}`}
        onClick={() => {
          if (file) {
            onPreview && onPreview();
          } else if (!isViewOnly) {
            inputRef?.current?.click();
          }
        }}
      >
        {file ? (
          <>
            {file.type?.startsWith("image/") ? (
              <img src={file.url} alt={title} className="document-thumb" />
            ) : (
              ""
            )}

            <span className="document-name">{file.name}</span>

            <small>{file.size}</small>

            {!isViewOnly && onRemove && (
              <button
                className="remove-file"
                onClick={(e) => {
                  e.stopPropagation();
                  onRemove();
                }}
              >
                {/* <X size={11} /> */}
              </button>
            )}
          </>
        ) : (
          <>
            <span style={{ fontSize: 12 }}>{title}</span>

            <small style={{ fontSize: 12 }}>JPG / PNG / PDF</small>
          </>
        )}
      </div>
    </>
  );
};

export default DriverVerification;
